<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" height="900px" >
    <v-card class="d-flex justify-content-center">
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <v-card-text>
        <div class="text-center py-10">
          <v-img
            @click="closeDialog"
            class="cancel-image"
            src="../assets/icons/cancel.png"
            height="15px"
            width="15px"
          />
          <h3>{{ dialogTitle }}</h3>
        </div>

        <embed src="docs/uws_cloud_terms_page.pdf" type="application/pdf" width="100%" height="1000px"/>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
<script>
import { translateFunc } from '../common/Filters';

export default {
  name: "TermsModal",
  
  data() {
    return {
      dialog: false,
      showLoading: false,
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.v-dialog:not(.v-dialog--fullscreen){
  height: 90% !important;
}
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 90%;
}
.cancel-image {
  cursor: pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
</style>
  